import type React from 'react'

export interface CorpVars {
  agreement_number: string
  agreement_date: string
  agreement_city: string
  customer_legal_name: string
  customer_short_name: string
  customer_director_name: string
  customer_inn: string
  customer_kpp: string
  customer_ogrn: string
  customer_legal_address: string
  customer_actual_address: string
  customer_bank_name: string
  customer_bank_bik: string
  customer_correspondent_account: string
  customer_current_account: string
  customer_phone: string
  customer_email: string
}

export const DEFAULT_CORP: CorpVars = {
  agreement_number: '',
  agreement_date: new Date().toISOString().slice(0, 10),
  agreement_city: 'г. Москва',
  customer_legal_name: '',
  customer_short_name: '',
  customer_director_name: '',
  customer_inn: '',
  customer_kpp: '',
  customer_ogrn: '',
  customer_legal_address: '',
  customer_actual_address: '',
  customer_bank_name: '',
  customer_bank_bik: '',
  customer_correspondent_account: '',
  customer_current_account: '',
  customer_phone: '',
  customer_email: '',
}

export function toCorpManualVariables(vars: CorpVars): Record<string, unknown> {
  return { ...vars }
}

const labelStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  fontSize: '0.85rem',
  marginBottom: '0.65rem',
}

const inputStyle: React.CSSProperties = {
  padding: '0.45rem 0.55rem',
  borderRadius: '8px',
  border: '1px solid #d0d7de',
  fontSize: '0.9rem',
}

const sectionTitle: React.CSSProperties = {
  margin: '0.75rem 0 0.35rem',
  fontSize: '0.95rem',
  fontWeight: 600,
}

interface Props {
  vars: CorpVars
  onChange: (v: CorpVars) => void
}

function Field({
  label,
  value,
  onChange,
  placeholder,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  placeholder?: string
}) {
  return (
    <label style={labelStyle}>
      {label}
      <input
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        style={inputStyle}
      />
    </label>
  )
}

export function CorpAgreementProposalForm({ vars, onChange }: Props) {
  const set = (patch: Partial<CorpVars>) => onChange({ ...vars, ...patch })
  return (
    <div>
      <p style={{ fontSize: '0.85rem', color: '#57606a', marginBottom: '0.5rem' }}>
        Корпоративный договор без AI: реквизиты Исполнителя подставляются из карточки клиники тенанта,
        Заказчик заполняется вручную.
      </p>
      <h4 style={sectionTitle}>Договор</h4>
      <Field label="Номер" value={vars.agreement_number} onChange={(v) => set({ agreement_number: v })} placeholder="КОРП-11/2026-1" />
      <Field label="Дата" value={vars.agreement_date} onChange={(v) => set({ agreement_date: v })} placeholder="2026-06-23" />
      <Field label="Город" value={vars.agreement_city} onChange={(v) => set({ agreement_city: v })} placeholder="г. Москва" />

      <h4 style={sectionTitle}>Заказчик</h4>
      <Field label="Полное наименование" value={vars.customer_legal_name} onChange={(v) => set({ customer_legal_name: v })} />
      <Field label="Краткое наименование" value={vars.customer_short_name} onChange={(v) => set({ customer_short_name: v })} placeholder='ООО «...»' />
      <Field label="Генеральный директор" value={vars.customer_director_name} onChange={(v) => set({ customer_director_name: v })} />

      <h4 style={sectionTitle}>Реквизиты Заказчика (приложения 4, гарантийные письма)</h4>
      <Field label="ИНН" value={vars.customer_inn} onChange={(v) => set({ customer_inn: v })} />
      <Field label="КПП" value={vars.customer_kpp} onChange={(v) => set({ customer_kpp: v })} />
      <Field label="ОГРН" value={vars.customer_ogrn} onChange={(v) => set({ customer_ogrn: v })} />
      <Field label="Юр. адрес" value={vars.customer_legal_address} onChange={(v) => set({ customer_legal_address: v })} />
      <Field label="Факт. адрес" value={vars.customer_actual_address} onChange={(v) => set({ customer_actual_address: v })} />
      <Field label="Банк" value={vars.customer_bank_name} onChange={(v) => set({ customer_bank_name: v })} />
      <Field label="БИК" value={vars.customer_bank_bik} onChange={(v) => set({ customer_bank_bik: v })} />
      <Field label="К/с" value={vars.customer_correspondent_account} onChange={(v) => set({ customer_correspondent_account: v })} />
      <Field label="Р/с" value={vars.customer_current_account} onChange={(v) => set({ customer_current_account: v })} />
      <Field label="Телефон" value={vars.customer_phone} onChange={(v) => set({ customer_phone: v })} />
      <Field label="E-mail" value={vars.customer_email} onChange={(v) => set({ customer_email: v })} />
    </div>
  )
}
